"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceEnterpriseParcels = exports.ServiceProfessionalParcels = exports.ServiceStarterParcels = exports.ServiceFreeParcels = exports.MarketingBasicParcels = exports.MarketingProParcels = exports.MarketingEnterpriseParcels = exports.MarketingStarterParcels = exports.MarketingFreeParcels = exports.SalesEnterpriseParcels = exports.SalesStarterParcels = exports.SalesProfessionalParcels = exports.SalesProParcels = exports.SalesPowerParcels = exports.SalesFreeParcels = exports.StandaloneCMSPaidParcels = exports.StandaloneCMSFreeParcels = exports.SitesParcels = exports.OtherParcelMappings = void 0;

var _immutable = require("immutable");

var OtherParcelMappings = (0, _immutable.Map)({
  ads: 'Ads',
  reporting: 'Reporting',
  'content-ssl': 'SSL'
});
exports.OtherParcelMappings = OtherParcelMappings;
var SitesParcels = (0, _immutable.Set)(['sites', 'sites-grandfathered']);
exports.SitesParcels = SitesParcels;
var StandaloneCMSFreeParcels = (0, _immutable.Set)(['cms-standalone-free']);
exports.StandaloneCMSFreeParcels = StandaloneCMSFreeParcels;
var StandaloneCMSPaidParcels = (0, _immutable.Set)(['cms-standalone-paid']);
exports.StandaloneCMSPaidParcels = StandaloneCMSPaidParcels;
var SalesFreeParcels = (0, _immutable.Set)(['sales']);
exports.SalesFreeParcels = SalesFreeParcels;
var SalesPowerParcels = (0, _immutable.Set)(['sales-power']);
exports.SalesPowerParcels = SalesPowerParcels;
var SalesProParcels = (0, _immutable.Set)(['sales-pro']);
exports.SalesProParcels = SalesProParcels;
var SalesProfessionalParcels = (0, _immutable.Set)(['sales-pro-bundle']);
exports.SalesProfessionalParcels = SalesProfessionalParcels;
var SalesStarterParcels = (0, _immutable.Set)(['sales-starter']);
exports.SalesStarterParcels = SalesStarterParcels;
var SalesEnterpriseParcels = (0, _immutable.Set)(['sales-enterprise-bundle']);
exports.SalesEnterpriseParcels = SalesEnterpriseParcels;
var MarketingFreeParcels = (0, _immutable.Set)(['marketing-free-2016', 'marketing-starter']);
exports.MarketingFreeParcels = MarketingFreeParcels;
var MarketingStarterParcels = (0, _immutable.Set)(['marketing-starter-2016', 'marketing-starter-2018', 'marketing-starter']);
exports.MarketingStarterParcels = MarketingStarterParcels;
var MarketingEnterpriseParcels = (0, _immutable.Set)(['marketing-ent-2011', 'marketing-ent-2012', 'marketing-ent-2013', 'marketing-ent-trial-2011', 'marketing-ent-trial-2012', 'marketing-ent-trial-2013', 'marketing-large-legacy', 'marketing-hubspot-free', 'marketing-ent', 'marketing-enterprise']);
exports.MarketingEnterpriseParcels = MarketingEnterpriseParcels;
var MarketingProParcels = (0, _immutable.Set)(['marketing-pro-2011', 'marketing-pro-2012', 'marketing-pro-2013', 'marketing-pro-trial-2011', 'marketing-pro-trial-2012', 'marketing-pro-trial-2013', 'marketing-marketer', 'marketing-medium-legacy', 'marketing-medium-trial-legacy', 'marketing-pro']);
exports.MarketingProParcels = MarketingProParcels;
var MarketingBasicParcels = (0, _immutable.Set)(['marketing-basic-2011', 'marketing-basic-2012', 'marketing-basic-2013', 'marketing-basic-trial-2011', 'marketing-basic-trial-2012', 'marketing-basic-trial-2013', 'marketing-angel-small', 'marketing-partner-basic-2011', 'marketing-partner-basic-legacy', 'marketing-owner', 'marketing-small-legacy', 'marketing-small-trial-legacy', 'marketing-basic']);
exports.MarketingBasicParcels = MarketingBasicParcels;
var ServiceFreeParcels = (0, _immutable.Set)(['service-free']);
exports.ServiceFreeParcels = ServiceFreeParcels;
var ServiceStarterParcels = (0, _immutable.Set)(['service-starter']);
exports.ServiceStarterParcels = ServiceStarterParcels;
var ServiceProfessionalParcels = (0, _immutable.Set)(['service-professional-bundle']);
exports.ServiceProfessionalParcels = ServiceProfessionalParcels;
var ServiceEnterpriseParcels = (0, _immutable.Set)(['service-enterprise-bundle']);
exports.ServiceEnterpriseParcels = ServiceEnterpriseParcels;